import { CategoryTreeService } from "@/services/categoryTree/categoryTree.service";

export function useCategoryTree(id: string | undefined) {
  const { data, error, isLoading } = CategoryTreeService.getCategoryTree(id);

  return {
    categoryTree: data,
    error,
    isLoading,
  };
}
